import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { OptionService } from "../option/option.service";

@Component({
    selector: 'footerdata',
    templateUrl: './output.footerdata.component.html'
})
export class FooterdataComponent implements OnInit {
    /**
     * the current step
     */
    @Input() step: string;

    /**
     * the current size
     */
    @Input() size: string;

    /**
     * version of the visualisation
     *
     * @type {String}
     */
    @Input() version: string;

    /**
     * Current type of the project
     */
    @Input() projectType: string = null;

    /**
     * Toggle for hinding the payment icons.
     */
    @Input() hidePaymentIcons = false;

    /**
     * Output for step change
     * @type {EventEmitter}
     */
    @Output() stepChange: EventEmitter<string> = new EventEmitter();

    /**
     * flag to hide payment preview icons
     */
    hasHidePaymentIcons: boolean = false;

    /**
     * Holds the type of footer that should be visible
     * @type {any}
     */
    footer: string = null;

    /**
     * holds an optional privacy url
     *
     * @type {String}
     */
    privacy_url: string = null;

    /**
     * holds the impress url if there is one set
     *
     * @type {String}
     */
    impress_url: string;

    /**
     * Constructor
     * @param optionService
     */
    constructor(private optionService: OptionService) {}

    /**
     * Initi the component
     */
    public ngOnInit(): void {
        // get the footer from the organisation date
        this.footer = this.optionService.getOrganisationData("footer");

        // get the privacy and impress urls
        this.privacy_url = this.optionService.getOrganisationData('privacy_url');
        this.impress_url = this.optionService.getOrganisationData('impress_url');

        // flag for payment preview icons
        this.hasHidePaymentIcons = this.optionService.getOrganisationData('has_hide_paymenticons')
    }

    /**
     * Returns a list of classes that should be set to the footer
     * @returns {string}
     */
    getClass(): string {
        let cssClass = this.step + ' ' + this.version;

        if (this.footer != null) {
            cssClass += " footer-" + this.footer;
        }

        const isValidVersion = ['widget', 'shop', 'giftshop'].includes(this.version);
        const isPageAndSmall = this.version === 'page' && this.size === 'small';

        if (!this.hasHidePaymentIcons && (isValidVersion || isPageAndSmall)) {
            cssClass += " footer-payment-preview";
        }

        return cssClass;
    }

    /**
     * Shows the data protection step
     */
    showDataprotection(): void {
        if(!this.privacy_url || (this.privacy_url.length === 0 && this.step != "dataprotection")) {
            this.step = "dataprotection";
            this.stepChange.emit(this.step);
        }
    }

    /**
     * Shows the impress text
     */
    showImpress(): void {
        if(this.impress_url === null && this.step != "impress") {
            this.step = "impress";
            this.stepChange.emit(this.step);
        }
    }

}
